import { Children, isValidElement } from "react";
import { useSidebarSettings } from "./SidebarSettingsContext";
import { useAdminAccess } from "../access/AdminAccessContext";

export default function OrderedSidebarItems({ children }) {
  const { order, isLoading } = useSidebarSettings();
  const { canMenuGroup } = useAdminAccess();
  const nodes = Children.toArray(children).filter(node => !isValidElement(node) || !node.props["data-sidebar-id"] || canMenuGroup(node.props["data-sidebar-id"]));
  const isMenuItem = (node) => isValidElement(node) && node.props["data-sidebar-id"];
  const positions = new Map(order.map((id, index) => [id, index]));
  const sorted = nodes.filter(isMenuItem).sort((a, b) =>
    (positions.get(a.props["data-sidebar-id"]) ?? Infinity) -
    (positions.get(b.props["data-sidebar-id"]) ?? Infinity)
  );
  let index = 0;

  return (
    <ul className="flex flex-col items-start w-full" aria-label="منوی اصلی مدیریت" aria-busy={isLoading}>
      {isLoading ? (
        <li className="w-full rounded-xl bg-slate-50 px-4 py-5 text-sm text-slate-500 dark:bg-slate-800 dark:text-slate-400" role="status">
          در حال دریافت منو…
        </li>
      ) : nodes.map((node) => isMenuItem(node) ? sorted[index++] : node)}
    </ul>
  );
}
